import { type ReactNode, useState } from 'react';
import { Calculator } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Modal } from '@/components/ui/modal';
import { useCalculatePayments } from '../hooks/use-calculate-payments';
import { CalculatePaymentsModalContent } from './calculate-payments-modal-content';

export function CalculatePaymentsButton(): ReactNode {
  const [open, setOpen] = useState(false);
  const calc = useCalculatePayments();
  const close = (): void => setOpen(false);
  return (
    <>
      <Button
        size="sm"
        onClick={() => setOpen(true)}
        disabled={calc.isPending}
        className="gap-1"
      >
        <Calculator size={14} />
        {calc.isPending ? 'Calculando…' : 'Calcular pagos'}
      </Button>
      <Modal open={open} onClose={close} title="Calcular pagos">
        <CalculatePaymentsModalContent
          isPending={calc.isPending}
          onConfirm={() => calc.mutate(undefined, { onSuccess: close })}
          onCancel={close}
        />
      </Modal>
    </>
  );
}
